import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import { createSelector } from 'reselect';
export const getBrandSettings = state => state.resources.brandSettings.brandSettings;
export const getBrandSettingsFetchStatus = state => {
  var _state$resources$bran;
  return (_state$resources$bran = state.resources.brandSettings) === null || _state$resources$bran === void 0 ? void 0 : _state$resources$bran.requestStatus;
};
export const getBrandColors = createSelector([getBrandSettings], brandSettings => brandSettings && brandSettings.colors || []);
export const getBrandColorsFetchStatus = state => {
  return state.resources.brandSettings.colorsRequestStatus;
};
export const getBrandLogos = createSelector([getBrandSettings], brandSettings => brandSettings && brandSettings.logos || []);
export const getBusinessUnitId = (state, props) => {
  var _contentSchema$conten, _state$resources$bran2;
  const {
    contentSchema
  } = state;
  // ensure buid 0 is returned
  if (!isNullOrUndefined(contentSchema === null || contentSchema === void 0 || (_contentSchema$conten = contentSchema.content) === null || _contentSchema$conten === void 0 ? void 0 : _contentSchema$conten.businessUnitId)) {
    return contentSchema.content.businessUnitId;
  }
  return props.businessUnitId || ((_state$resources$bran2 = state.resources.brandSettings) === null || _state$resources$bran2 === void 0 ? void 0 : _state$resources$bran2.businessUnitId);
};
export const getBrandKitId = (state, props) => {
  var _state$resources$bran3;
  return (props === null || props === void 0 ? void 0 : props.brandKitId) || ((_state$resources$bran3 = state.resources.brandSettings) === null || _state$resources$bran3 === void 0 ? void 0 : _state$resources$bran3.brandKitId);
};
export const getContentCategoryName = state => state.contentSchema && state.contentSchema.categoryName;
export const getBrandedLogoValue = state => {
  return state.resources.brandSettings.brandedLogo || {};
};